import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=4ec87bf0&"
import script from "./reports.vue?vue&type=script&lang=js&"
export * from "./reports.vue?vue&type=script&lang=js&"
import style0 from "./reports.vue?vue&type=style&index=0&id=4ec87bf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports